/**
 * Přibližná poloha z IP (bez GPS). Přesnost typicky desítky až stovky km.
 * Prohlížeč může volat z HTTPS; záložní zdroj při chybě prvního.
 */

const GEOJS_URL = "https://get.geojs.io/v1/ip/geo.json";
const IPAPI_FALLBACK = "https://ipapi.co/json/";

function parseLatLon(
  lat: unknown,
  lon: unknown
): { latitude: number; longitude: number } | null {
  const latitude = typeof lat === "string" ? parseFloat(lat) : Number(lat);
  const longitude = typeof lon === "string" ? parseFloat(lon) : Number(lon);
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;
  if (Math.abs(latitude) > 90 || Math.abs(longitude) > 180) return null;
  return { latitude, longitude };
}

export async function fetchApproximateLocationByIp(): Promise<{
  latitude: number;
  longitude: number;
} | null> {
  try {
    const r = await fetch(GEOJS_URL, { cache: "no-store" });
    if (r.ok) {
      const j = (await r.json()) as { latitude?: unknown; longitude?: unknown };
      const c = parseLatLon(j.latitude, j.longitude);
      if (c) return c;
    }
  } catch {
    // zkusit zálohu
  }
  try {
    const r2 = await fetch(IPAPI_FALLBACK, { cache: "no-store" });
    if (r2.ok) {
      const j2 = (await r2.json()) as { error?: boolean; latitude?: unknown; longitude?: unknown };
      if (j2.error) return null;
      const c = parseLatLon(j2.latitude, j2.longitude);
      if (c) return c;
    }
  } catch {
    // nic
  }
  return null;
}

/** Přesnost ~50 km — aby UI neukazovalo falešně „dobrou“ metriku jako u GPS. */
const IP_FAKE_ACCURACY_METERS = 50_000;

export function toGeolocationCoordinatesFromIp(
  loc: { latitude: number; longitude: number }
): GeolocationCoordinates {
  return {
    latitude: loc.latitude,
    longitude: loc.longitude,
    accuracy: IP_FAKE_ACCURACY_METERS,
    altitude: null,
    altitudeAccuracy: null,
    heading: null,
    speed: null,
  } as GeolocationCoordinates;
}
